import React from "react";
import "./Instructions.css";

const Instructions = props => (
  <div className="instructions">{props.instructions}</div>
);

export default Instructions;